import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { websiteConfigApi } from '../services/api'

// Async thunks
export const fetchConfigs = createAsyncThunk(
  'websiteConfig/fetchConfigs',
  async (params) => {
    const response = await websiteConfigApi.list(params)
    return response
  }
)

export const addConfig = createAsyncThunk(
  'websiteConfig/addConfig',
  async (configData) => {
    const response = await websiteConfigApi.create(configData)
    return response.data
  }
)

export const updateConfig = createAsyncThunk(
  'websiteConfig/updateConfig',
  async ({ id, ...configData }) => {
    const response = await websiteConfigApi.update(id, configData)
    return response.data
  }
)

export const deleteConfig = createAsyncThunk(
  'websiteConfig/deleteConfig',
  async (id) => {
    await websiteConfigApi.delete(id)
    return id
  }
)

const initialState = {
  configs: [],
  loading: false,
  error: null,
  pagination: {
    total: 0,
    page: 1,
    pageSize: 10,
    totalPages: 0
  },
  filters: {
    domain: '',
    country: '',
    whatsapp_phone: ''
  }
}

const websiteConfigSlice = createSlice({
  name: 'websiteConfig',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
      state.pagination.page = 1 // Reset to first page when filters change
    },
    setPage: (state, action) => {
      state.pagination.page = action.payload
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload
      state.pagination.page = 1 // Reset to first page when page size changes
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch configs
      .addCase(fetchConfigs.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchConfigs.fulfilled, (state, action) => {
        console.group('fetchConfigs.fulfilled')
        console.log(action.payload)
        console.groupEnd('fetchConfigs.fulfilled')
        const data = action.payload.data;
        state.loading = false
        state.configs = data.items
        state.pagination = {
          total: data.total,
          page: data.page,
          pageSize: data.pageSize,
          totalPages: data.totalPages
        }
      })
      .addCase(fetchConfigs.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message
      })
      // Add config
      .addCase(addConfig.fulfilled, (state, action) => {
        state.configs.push(action.payload)
      })
      // Update config
      .addCase(updateConfig.fulfilled, (state, action) => {
        const index = state.configs.findIndex(
          (config) => config.id === action.payload.id
        )
        if (index !== -1) {
          state.configs[index] = action.payload
        }
      })
      // Delete config
      .addCase(deleteConfig.fulfilled, (state, action) => {
        state.configs = state.configs.filter(
          (config) => config.id !== action.payload
        )
      })
  },
})

export const { setFilters, setPage, setPageSize } = websiteConfigSlice.actions
export default websiteConfigSlice.reducer 